import React from 'react'

import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { IntercomProvider } from 'react-use-intercom'

import { config } from '@fairhq/common'
import App from 'App'
import { ErrorBoundary } from 'ErrorBoundary'

import reportWebVitals from 'reportWebVitals'
import { store } from 'store/store'
import 'styles.css'
import 'i18n'

if (config.env !== 'local' && process.env.NODE_ENV === 'production') {
  Bugsnag.start({
    apiKey: '07c516d4123a324fc06597898e1b04e2',
    plugins: [new BugsnagPluginReact()],
    appVersion: config.version,
    releaseStage: config.env,
    sendCode: true,
    onError: event => {
      if (window.FS && window.FS.getCurrentSessionURL) {
        event.addMetadata('fullstory', {
          urlAtTime: window.FS.getCurrentSessionURL(true),
        })
      }
    },
  })
}

const container = document.getElementById('root')
const root = ReactDOM.createRoot(container!)

root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <IntercomProvider
        appId={config.intercomAppId}
        apiBase={process.env.INTERCOM_BASE_API}
        autoBoot={
          process.env.NODE_ENV === 'production' ||
          process.env.NODE_ENV === 'development'
        }
      >
        <App />
      </IntercomProvider>
    </Provider>
  </ErrorBoundary>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
